// extracted by mini-css-extract-plugin
module.exports = {"footerSocialLinks":"social-medias-module--footer-social-links--2Ko8C","footerSocialItem":"social-medias-module--footer-social-item--unP9F"};